var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { InputAdornment, TextField } from '@one-thd/sui-atomic-components';
import { Calendar } from '@one-thd/sui-icons';
import { DateTime } from 'luxon';
import React from 'react';
export var OrderFilterInput = function (_a) {
    var name = _a.name, dateType = _a.dateType, dateSettings = _a.dateSettings, setDateSettings = _a.setDateSettings, setFilterSettings = _a.setFilterSettings;
    var label = { inputProps: { 'aria-label': 'date range' } };
    return (React.createElement(TextField, { placeholder: "MM/DD/YYYY", id: "basic-input", fullWidth: true, value: dateSettings[dateType], label: name, onChange: function (event) {
            var _a, _b;
            var inputDate = event.target.value.replace(/[^0-9/]/g, '');
            if (inputDate.length > 10) {
                inputDate = inputDate.slice(0, 10);
            }
            if (inputDate.length === 2 &&
                ((_a = dateSettings[dateType]) === null || _a === void 0 ? void 0 : _a.toString().length) !== 3) {
                inputDate += '/';
            }
            else if (inputDate.length === 5 &&
                ((_b = dateSettings[dateType]) === null || _b === void 0 ? void 0 : _b.toString().length) !== 6) {
                inputDate += '/';
            }
            setDateSettings(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[dateType] = inputDate, _a)));
            });
            if (inputDate.length === 10) {
                var parsedDate = DateTime.fromFormat(inputDate, 'MM/dd/yyyy');
                var month = parsedDate.month;
                var day = parsedDate.day;
                var year_1 = parsedDate.year;
                var monthString_1 = month < 10 ? "0".concat(month) : "".concat(month);
                var dayString_1 = day < 10 ? "0".concat(day) : "".concat(day);
                if (parsedDate.isValid) {
                    setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { customDateUsed: true })); });
                    setDateSettings(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = { selectedDate: 'custom' }, _a[dateType] = "".concat(monthString_1, "/").concat(dayString_1, "/").concat(year_1), _a)));
                    });
                }
            }
            if (inputDate.length > 0) {
                setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { customDateUsed: true })); });
            }
        }, InputProps: __assign({ endAdornment: (React.createElement(InputAdornment, { position: "end" },
                React.createElement("span", { className: "sui-cursor-pointer sui-flex", onClick: function () {
                        if (dateType === 'startDate') {
                            setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { showStartCalendar: true })); });
                        }
                        else if (dateType === 'endDate') {
                            setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { showEndCalendar: true })); });
                        }
                    }, onKeyDown: function () {
                        if (dateType === 'startDate') {
                            setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { showStartCalendar: true })); });
                        }
                        else if (dateType === 'endDate') {
                            setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { showEndCalendar: true })); });
                        }
                    }, tabIndex: 0, role: "button", "aria-label": "Open date picker" },
                    React.createElement(Calendar, { size: "small" })))) }, label) }));
};
